module.exports = __webpack_public_path__ + "img/home-banner.9347e900.png";